package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Instant

/**
 * Represents an active whiteboard.
 */
@Serializable
data class ActiveWhiteboard(
    @SerialName("id")
    val id: String,

    @SerialName("table_id")
    val tableId: String,

    @SerialName("created_by")
    val createdBy: String,

    @SerialName("target_participants")
    val targetParticipants: List<String>,

    @SerialName("is_active")
    val isActive: Boolean,

    @SerialName("show_grid")
    val showGrid: Boolean = false,

    @SerialName("created_at")
    val createdAt: Instant
)
